var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
/**
 * One possible-duplicate person surfaced when a receptionist opens a website
 * booking hold (PRD #1358, RS-008). A read-only projection composed by the
 * patient-booking BFF: the candidate existing person in the hold's office
 * location, plus the evidence for the match so a human can judge it. Advisory
 * only — the practice confirms onto this person or as a new one; nothing merges
 * automatically.
 */
export class DuplicatePersonMatchDto {
    /** The existing person's user id — the confirm-onto-existing target. */
    userId;
    /** The candidate's display name, so the receptionist recognises them. */
    fullName;
    /** The candidate's email, shown as evidence (may be null for walk-ins). */
    email;
    /** The candidate's phone, shown as evidence (may be null). */
    phone;
    /** The candidate's birthdate, shown as evidence to disambiguate namesakes. */
    birthdate;
    /** Why this candidate matched (strongest reason first). Rendered as the evidence. */
    reasons;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DuplicatePersonMatchDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DuplicatePersonMatchDto.prototype, "fullName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DuplicatePersonMatchDto.prototype, "email", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DuplicatePersonMatchDto.prototype, "phone", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Object)
], DuplicatePersonMatchDto.prototype, "birthdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], DuplicatePersonMatchDto.prototype, "reasons", void 0);
//# sourceMappingURL=duplicate-person-match.dto.js.map